var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountCameraMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43,12l-7,0.0009766V9c0-2.7568359-2.2431641-5-5-5H17c-2.7568359,0-5,2.2431641-5,5v3H5c-2.7568359,0-5,2.2431641-5,5v22 c0,2.7568359,2.2431641,5,5,5h38c2.7568359,0,5-2.2431641,5-5V17C48,14.2431641,45.7568359,12,43,12z M46,39 c0,1.6542969-1.3457031,3-3,3H5c-1.6542969,0-3-1.3457031-3-3V17c0-1.6542969,1.3457031-3,3-3h7c1.1030273,0,2-0.8974609,2-2V9 c0-1.6542969,1.3457031-3,3-3h14c1.6542969,0,3,1.3457031,3,3v3c0,1.1025391,0.8969727,2,2,2h7c1.6542969,0,3,1.3457031,3,3V39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16c-6.0654297,0-11,4.9345703-11,11s4.9345703,11,11,11s11-4.9345703,11-11S30.0654297,16,24,16z M24,36 c-4.9624023,0-9-4.0371094-9-9s4.0375977-9,9-9s9,4.0371094,9,9S28.9624023,36,24,36z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCameraMedium);
export default __webpack_public_path__ + "static/media/account-camera--medium.c7ece9f480a9bca40de98c65da89b41a.svg";
export { ForwardRef as ReactComponent };